import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { globalVars } from "../../global/GlobalVars.js";
import * as websocket from "../../utils/communication.js";
import * as language from "../../utils/language.js";
import AnalogInElement from "./AnalogInElement.jsx";
import { corr } from "mathjs";
import { se } from "date-fns/locale";

const AnalogIn = observer((props) => {
  //========================================================================
  // Datenpunkte anmelden
  useEffect(() => {
    let newReqDataValues = globalVars.reqDataValues;

    for (let i = 0; i < props.props.ioVariables.length; i++) {
      for (let j = 0; j < props.props.ioVariables[i].number; j++) {
        let varStringAi =
          props.props.ioVariables[i].variable + ".Kanal" + j + ".fAi";
        let varStringRaw =
          props.props.ioVariables[i].variable + ".Kanal" + j + ".nRaw";
        let varStringUpperLimit =
          props.props.ioVariables[i].variable + ".Kanal" + j + ".fUpperLimit";
        let varStringLowerLimit =
          props.props.ioVariables[i].variable + ".Kanal" + j + ".fLowerLimit";
        let varStringCorrection =
          props.props.ioVariables[i].variable + ".Kanal" + j + ".fCorrection";
        let varStringSensorMax =
          props.props.ioVariables[i].variable + ".Kanal" + j + ".fSensorMax";
        let varStringSensorMin =
          props.props.ioVariables[i].variable + ".Kanal" + j + ".fSensorMin";
        let varStringFaultSensor =
          props.props.ioVariables[i].variable + ".Kanal" + j + ".bFaultSensor";

        if (!newReqDataValues.includes(varStringAi)) {
          newReqDataValues.push(varStringAi);
        }
        if (!newReqDataValues.includes(varStringRaw)) {
          newReqDataValues.push(varStringRaw);
        }
        if (!newReqDataValues.includes(varStringUpperLimit)) {
          newReqDataValues.push(varStringUpperLimit);
        }
        if (!newReqDataValues.includes(varStringLowerLimit)) {
          newReqDataValues.push(varStringLowerLimit);
        }
        if (!newReqDataValues.includes(varStringCorrection)) {
          newReqDataValues.push(varStringCorrection);
        }
        if (!newReqDataValues.includes(varStringSensorMax)) {
          newReqDataValues.push(varStringSensorMax);
        }
        if (!newReqDataValues.includes(varStringSensorMin)) {
          newReqDataValues.push(varStringSensorMin);
        }
        if (!newReqDataValues.includes(varStringFaultSensor)) {
          newReqDataValues.push(varStringFaultSensor);
        }
      }
    }

    if (newReqDataValues.length > 0) {
      globalVars.setReqDataValues(newReqDataValues);
      websocket.registerDataPoints(
        globalVars.ws,
        globalVars.reqDataValues,
        "register",
      );
    }
  }, []);

  //========================================================================
  // Variablennamen zusammensetzen
  let dat = [];

  for (let i = 0; i < props.props.ioVariables.length; i++) {
    for (let j = 0; j < props.props.ioVariables[i].number; j++) {
      dat.push({
        anaIn: props.props.ioVariables[i].variable + ".Kanal" + j + ".fAi",
        raw: props.props.ioVariables[i].variable + ".Kanal" + j + ".nRaw",
        upperLimit:
          props.props.ioVariables[i].variable + ".Kanal" + j + ".fUpperLimit",
        lowerLimit:
          props.props.ioVariables[i].variable + ".Kanal" + j + ".fLowerLimit",
        correction:
          props.props.ioVariables[i].variable + ".Kanal" + j + ".fCorrection",
        sensorMax:
          props.props.ioVariables[i].variable + ".Kanal" + j + ".fSensorMax",
        sensorMin:
          props.props.ioVariables[i].variable + ".Kanal" + j + ".fSensorMin",
        faultSensor:
          props.props.ioVariables[i].variable + ".Kanal" + j + ".bFaultSensor",
      });
    }
  }

  let names = props.element.ioNames;

  //========================================================================
  // Grafische Darstellung
  return (
    <div
      style={{
        ...props.style,
        overflowY: "auto",
        backgroundColor: "#53535399",
        display: "grid",
        gap: "1.2%",
        alignItems: "baseline",
        alignContent: "baseline",
      }}
    >
      <div
        style={{
          position: "sticky",
          top: 0,
          left: `calc(${globalVars.scaleFactor} * 10px)`,
          width: `calc(100% - (${globalVars.scaleFactor} * 30px))`,
          height: `calc(${globalVars.scaleFactor} * 40px)`,
          backgroundColor: "#3f3f3f",
          color: "white",
          fontWeight: "bold",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          padding: "0",
          paddingLeft: `calc(${globalVars.scaleFactor} * 10px)`,
          zIndex: 2,
        }}
      >
        <div
          style={{
            position: "absolute",
            left: `calc(${globalVars.scaleFactor} * 10px)`,
            width: `calc(${globalVars.scaleFactor} * 200px)`,
            textAlign: "left",
          }}
        >
          {language.displayText(["Bezeichnung", "", ""])}
        </div>
        <div
          style={{
            position: "absolute",
            right: `calc(${globalVars.scaleFactor} * 761px)`,
            width: `calc(${globalVars.scaleFactor} * 80px)`,
            textAlign: "center",
          }}
        >
          {language.displayText(["Wert", "", ""])}
        </div>
        <div
          style={{
            position: "absolute",
            right: `calc(${globalVars.scaleFactor} * 646px)`,
            width: `calc(${globalVars.scaleFactor} * 80px)`,
            textAlign: "center",
          }}
        >
          {language.displayText(["Rohwert", "", ""])}
        </div>
        <div
          style={{
            position: "absolute",
            right: `calc(${globalVars.scaleFactor} * 531px)`,
            width: `calc(${globalVars.scaleFactor} * 80px)`,
            textAlign: "center",
          }}
        >
          {language.displayText(["Obergrenze", "", ""])}
        </div>
        <div
          style={{
            position: "absolute",
            right: `calc(${globalVars.scaleFactor} * 416px)`,
            width: `calc(${globalVars.scaleFactor} * 80px)`,
            textAlign: "center",
          }}
        >
          {language.displayText(["Untergrenze", "", ""])}
        </div>
        <div
          style={{
            position: "absolute",
            right: `calc(${globalVars.scaleFactor} * 301px)`,
            width: `calc(${globalVars.scaleFactor} * 80px)`,
            textAlign: "center",
          }}
        >
          {language.displayText(["Korrektur", "", ""])}
        </div>
        <div
          style={{
            position: "absolute",
            right: `calc(${globalVars.scaleFactor} * 186px)`,
            width: `calc(${globalVars.scaleFactor} * 80px)`,
            textAlign: "center",
          }}
        >
          {language.displayText(["Sensor max.", "", ""])}
        </div>
        <div
          style={{
            position: "absolute",
            right: `calc(${globalVars.scaleFactor} * 71px)`,
            width: `calc(${globalVars.scaleFactor} * 80px)`,
            textAlign: "center",
          }}
        >
          {language.displayText(["Sensor min.", "", ""])}
        </div>
        <div
          style={{
            position: "absolute",
            right: `calc(${globalVars.scaleFactor} * 15px)`,
            width: `calc(${globalVars.scaleFactor} * 40px)`,
            textAlign: "center",
          }}
        >
          {language.displayText(["Sensor-fehler", "", ""])}
        </div>
      </div>

      {Array.isArray(dat) &&
        dat.map((item, index) => (
          <AnalogInElement
            data={item}
            name={names?.[index] ?? "error"}
            style={props.style}
            authWrite={props.authWrite}
          />
        ))}
    </div>
  );
});

export default AnalogIn;
